import { MARQUEE_PHRASES } from "@/data/site";

export default function Marquee() {
  const row = [...MARQUEE_PHRASES, ...MARQUEE_PHRASES];
  return (
    <div data-testid="editorial-marquee" className="border-y hairline py-8 md:py-10 overflow-hidden" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic font-light text-3xl md:text-5xl text-ivory/70 px-8 md:px-12">
                  {p}
                </span>
                <span className="text-gold text-xs">&#9670;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
